import { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, Spin, Typography } from 'antd';
import { DollarOutlined, ShoppingCartOutlined, CalendarOutlined, RiseOutlined } from '@ant-design/icons';
import { crmApi } from '../../../api/client';

const { Text } = Typography;

interface ContractorOverviewStatsProps {
    contractorId: string;
}

export const ContractorOverviewStats = ({ contractorId }: ContractorOverviewStatsProps) => {
    const [stats, setStats] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await crmApi.getContractorStats(contractorId);
                setStats(response.data);
            } catch (error) {
                console.error('Failed to fetch contractor stats', error);
            } finally {
                setLoading(false);
            }
        };

        if (contractorId) {
            fetchStats();
        }
    }, [contractorId]);

    if (loading) return <Spin size="small" />;
    if (!stats) return null;

    const cardStyle = {
        borderRadius: 8,
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
        border: '1px solid #f0f0f0',
        height: '100%'
    };

    const daysColor = (stats.daysSinceLastOrder || 0) > 60 ? '#cf1322' : undefined;

    return (
        <Row gutter={[16, 16]}>
            <Col xs={12} sm={6}>
                <Card size="small" bodyStyle={{ padding: 12 }} style={cardStyle}>
                    <Statistic
                        title={<Text type="secondary" style={{ fontSize: 12 }}>Przychód (12m)</Text>}
                        value={stats.revenue12m}
                        precision={0}
                        prefix={<DollarOutlined />}
                        suffix="zł"
                        valueStyle={{ fontSize: 18, fontWeight: 600, color: '#3f8600' }}
                    />
                </Card>
            </Col>
            <Col xs={12} sm={6}>
                <Card size="small" bodyStyle={{ padding: 12 }} style={cardStyle}>
                    <Statistic
                        title={<Text type="secondary" style={{ fontSize: 12 }}>Liczba Zam.</Text>}
                        value={stats.ordersCount}
                        prefix={<ShoppingCartOutlined />}
                        valueStyle={{ fontSize: 18, fontWeight: 600 }}
                    />
                </Card>
            </Col>
            <Col xs={12} sm={6}>
                <Card size="small" bodyStyle={{ padding: 12 }} style={cardStyle}>
                    <Statistic
                        title={<Text type="secondary" style={{ fontSize: 12 }}>AOV</Text>}
                        value={stats.aov}
                        precision={0}
                        prefix={<RiseOutlined />}
                        suffix="zł"
                        valueStyle={{ fontSize: 18, fontWeight: 600 }}
                    />
                </Card>
            </Col>
            <Col xs={12} sm={6}>
                <Card size="small" bodyStyle={{ padding: 12 }} style={cardStyle}>
                    <Statistic
                        title={<Text type="secondary" style={{ fontSize: 12 }}>Ost. Zamówienie</Text>}
                        value={stats.daysSinceLastOrder === -1 ? '-' : `${stats.daysSinceLastOrder} dni temu`}
                        prefix={<CalendarOutlined />}
                        valueStyle={{ fontSize: 18, fontWeight: 600, color: daysColor }}
                    />
                </Card>
            </Col>
        </Row>
    );
};
